export default __webpack_public_path__ + "static/media/card-03.e9fa52c9.jpg";